module.exports = __webpack_public_path__ + "static/media/p5_4.c5caca30.jpeg";